import { useTranslation } from "react-i18next";
import "../../../styles/mapStyles/Popup.css";

function SoilInfoLoadingIndicator() {
  const { t } = useTranslation();
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>{t("soil.analyzingNearbySamples")}</p>
    </div>
  );
}

export default SoilInfoLoadingIndicator;
